// src/layout/MobileTabBar.jsx
// スマホ用の下部タブバー【2026-07-21】
// - 800px以下でのみ表示（CSS制御）
// - ロール別メニューの先頭3項目 + 「メニュー」(ドロワーを開く) の4タブ
import React from 'react';
import { NavLink } from 'react-router-dom';
import { getMenuItems } from '../config/menu';
import Icon from '../components/Icon';

export default function MobileTabBar({ user, onMenuClick = () => {} }) {
  const items = getMenuItems(user).slice(0, 3);
  return (
    <nav className="mobile-tabbar">
      {items.map(it => (
        <NavLink
          key={it.to}
          to={it.to}
          end={it.to === '/'}
          className={({ isActive }) => 'mobile-tab' + (isActive ? ' active' : '')}
        >
          <span className="mobile-tab-icon"><Icon name={it.icon} size={22} /></span>
          <span className="mobile-tab-label">{it.label}</span>
        </NavLink>
      ))}
      <button className="mobile-tab" onClick={onMenuClick}>
        <span className="mobile-tab-icon"><Icon name="menu" size={22} /></span>
        <span className="mobile-tab-label">メニュー</span>
      </button>
    </nav>
  );
}
